/**
 * Reconciliation API client. Thin wrappers over the Firebase-authed apiRequest
 * base, hitting /api/admin/reconciliation.
 */

import { apiRequest } from './api';
import { ReconciliationRunState, ReconciliationStatus } from '../components/Reconciliation/types';

const BASE = '/api/admin/reconciliation';

export async function getReconciliationStatus(): Promise<ReconciliationStatus> {
  return apiRequest(`${BASE}/status`);
}

/** The latest persisted run (status + report). `state` is null before the first run. */
export async function getReconciliationReport(): Promise<{ state: ReconciliationRunState | null; inFlight: boolean }> {
  return apiRequest(`${BASE}/report`);
}

/**
 * Kick off a reconciliation run (detached — returns 202). Poll
 * getReconciliationReport until `state.status !== 'running'`.
 */
export async function runReconciliation(body?: {
  minDays?: number;
  maxDays?: number;
  export?: boolean;
  refreshGam?: boolean;
}): Promise<{ status: string }> {
  return apiRequest(`${BASE}/run`, { method: 'POST', body: JSON.stringify(body ?? {}) });
}
